import React from 'react';

import { FormattedMessage } from 'react-intl';

import { messages } from './messages';

export const PickupLabel = () => <FormattedMessage {...messages.label} />;
